import { List, ListItem, Navbar, Page } from "framework7-react";
import { useState } from "react";

import { ChangeEmailForm } from "@/components/ChangeEmailForm";
import { NavLeftBack } from "@/components/NavLeftBack";
import { NavRightEmpty } from "@/components/NavRightEmpty";
import { NavTitle } from "@/components/NavTitle";
import { createPage, PageComponentProps } from "@/factories/createPage";
import { usePageReady } from "@/hooks/usePageReady";
import { useAuthStore } from "@/stores/authStore";

export const ChangeEmailPage = createPage("ChangeEmailPage", PageComponent);

function PageComponent({ pageName }: PageComponentProps) {
  const { currentUser } = useAuthStore();
  const { getPageProps } = usePageReady(pageName);

  const [isChange, setIsChange] = useState(false);

  return (
    <Page
      data-component={pageName}
      {...getPageProps()}
    >
      <Navbar>
        <NavLeftBack />
        <NavTitle>メールアドレス確認・変更</NavTitle>
        <NavRightEmpty />
      </Navbar>

      {isChange ? (
        <ChangeEmailForm onCompleted={() => setIsChange(false)} />
      ) : (
        <List
          dividersIos
          outlineIos
          strongIos
        >
          <ListItem
            after="変更"
            header="email"
            link="#"
            title={currentUser?.email || ""}
            onClick={() => setIsChange(true)}
          />
        </List>
      )}
    </Page>
  );
}
